module.exports = __webpack_public_path__ + "static/media/dog2.63ae4691.jpg";